@if (breakpointObserver.breakpointChange$ | async) {
   <div class="d-flex">
      @if (breakpointObserver.isBreakpointActive(['xl', 'xxl'])) {
         <div class="left-content">
            <cx-page-slot position="SikoBlogCategoriesSlot"></cx-page-slot>
            <cx-page-slot class="mt-5" position="SikoBlogSideSlot"></cx-page-slot>
         </div>
      }
      <div class="right-content">
         <cx-page-slot position="SikoBlogDetailComponentSlot"></cx-page-slot>
         <cx-page-slot position="SikoBlogDetailNarrowContentSlot"></cx-page-slot>
         <cx-page-slot position="SikoBlogDetailContextualPagesSlot"></cx-page-slot>
         @if (!breakpointObserver.isBreakpointActive(['xl', 'xxl'])) {
            <cx-page-slot class="mt-5 mb-5" position="SikoBlogSideSlot"></cx-page-slot>
         }
      </div>
   </div>
   <div class="d-block">
      <cx-page-slot position="SikoBlogDetailWideContentSlot"></cx-page-slot>
   </div>
}
